import type { FaireProductEntity } from "../../entity_types/product";

export const p_6rwqbht8gc: FaireProductEntity = {
  token: "p_6rwqbht8gc",
  type: "product",
  name: "Bohemian Shorts 1A, Large",
  brandToken: "b_46yqo0x0y0",
  brandName: "El Paso Saddleblanket",
  imageUrl:
    "https://cdn.faire.com/fastly/d9986fb827f8e0282b8d75aceaf6743c940057c8e7b5584dd234b6ab8243d577.jpeg",
  galleryImageUrls: [],
  priceDollars: 16.63,
  description:
    "Southwest Bohemian Shorts – Women’s Casual\n\nAdd vibrant Southwest style to your summer apparel collection with these comfortable Bohemian Shorts. Featuring bold geometric patterns and a relaxed fit, these shorts offer the perfect blend of fashion and everyday comfort.\n\nProduct Details:\n\n * \nMaterial: 95% Polyester / 5% Elastane – lightweight, breathable, and slightly stretchy for comfort\n\n * \nDesign: Southwest-inspired geometric patterns in rich desert tones\n\n * \nWaist: Elastic waistband with adjustable drawstring\n\n * \nFeatures: Side pockets for convenience\n\n * \nFit: Relaxed, comfortable fit ideal for warm-weather wear\n\n * \nSizes: Available in assorted sizes\n\nPerfect for boutiques and Western lifestyle retailers looking to add stylish, easy-to-wear summer apparel to their collection.\n",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:26.385Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
